import { Box, Button, Container, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Select, TextField, Typography } from "@mui/material";
import styleCss from "../Style/style";
import FooterLogo from '../img/blue-round-icon.png'
import { Link } from "react-router-dom"
import AppStore from "../img/appstorimg.png"
import PlayStore from "../img/playstore.png"
import MobileIcon from "../img/mobile-icon.png"
import MailIcon from "../img/mail-icon.png"
import AddressIcon from "../img/address-icon.png"
import Livechart from "../img/chart-icon.png"
import LanguageImg from "../img/language-icon.png"
import { useState } from "react"
import SaftyIcon from "../img/safty-icon.png"
import SaftyIcon1 from "../img/safty-icon1.png"
import SaftyIcon2 from "../img/safty-icon2.png"
import SocialIcon1 from "../img/social-icon1.png"
import SocialIcon2 from "../img/social-icon2.png"
import SocialIcon3 from "../img/social-icon3.png"
import SocialIcon4 from "../img/social-icon4.png"

const Footer = () => {
    const [value, setValue] = useState('');
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    return (
        <>
            <Grid sx={styleCss.FooterStyle}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <img src={FooterLogo} alt="" style={{ marginBottom: '20px' }} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ gap: '15px' }}>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <Typography sx={styleCss.FooterText}>
                                World’s largest online bus ticket
                                booking services trusted by over 25
                                million happy customer globally.
                            </Typography>
                            <Typography sx={styleCss.DownloadStyleHead}>
                                Download Our App
                            </Typography>
                            <Grid>
                                <Link to={'/'}>
                                    <img src={AppStore} alt="" style={{ marginTop: '15px', marginBottom: '15px' }} />
                                </Link>
                            </Grid>
                            <Grid>
                                <Link to={'/'}>
                                    <img src={PlayStore} alt="" style={{ marginBottom: '15px' }} />
                                </Link>
                            </Grid>
                        </Grid>
                        <Grid size={{ md: 2, xs: 12 }}>
                            <Typography sx={styleCss.QuickLinksstyle}>Quick Links</Typography>
                            <List>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>My Bookings</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>Track My Bus</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>Cancel Ticket</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/faq'} style={styleCss.Listview}>Print Ticket</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/faq'} style={styleCss.Listview}>Change Travel Date</Link>
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid size={{ md: 2, xs: 12 }}>
                            <Typography sx={styleCss.QuickLinksstyle}>Top Cities</Typography>
                            <List>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>Bengaluru</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>Chennai</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>Mumbai</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/faq'} style={styleCss.Listview}>Delhi</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/faq'} style={styleCss.Listview}>Pune</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/faq'} style={styleCss.Listview}>Hyderabad</Link>
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid size={{ md: 2, xs: 12 }}>
                            <Typography sx={styleCss.QuickLinksstyle}>Top Operators</Typography>
                            <List>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>VRL Travels</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>SRS Travels</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/'} style={styleCss.Listview}>KPN Travels</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/faq'} style={styleCss.Listview}>Orange Tours</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/faq'} style={styleCss.Listview}>Raj Travels</Link>
                                </ListItem>
                                <ListItem sx={{ paddingLeft: '0' }}>
                                    <Link to={'/faq'} style={styleCss.Listview}>Parveen Travels</Link>
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }}>
                            <Typography sx={styleCss.QuickLinksstyle1}>Supports</Typography>
                            <Typography sx={styleCss.MobileFontstyle}>
                                <img src={MobileIcon} alt="" style={{ verticalAlign: 'middle', marginRight: '3px' }} /> +91-999999999
                            </Typography>
                            <Typography sx={styleCss.MobileFontstyle}>
                                <img src={MailIcon} alt="" style={{ verticalAlign: 'middle', marginRight: '6px' }} /> Supports@starbus.in
                            </Typography>
                            <Typography sx={styleCss.MobileFontstyle}>
                                <img src={AddressIcon} alt="" style={{ verticalAlign: 'middle', marginRight: '6px' }} /> 24/7 Customer Supports
                            </Typography>
                            <Button variant="contained" style={{
                                padding: '5px 20px',
                                borderRadius: '5px',
                                backgroundColor: '#00a63e',
                                textTransform: 'capitalize',
                                width: '67%',
                                marginTop: '10px',
                            }}>
                                <img src={Livechart} alt="" style={{ marginRight: '3px', }} /> Live Chat
                            </Button>
                            <Grid sx={{ display: 'flex', marginTop: '20px', alignItems: 'center' }}>
                                <Grid sx={{ marginRight: '10px' }}>
                                    <img src={LanguageImg} alt="" />
                                </Grid>
                                <Grid>
                                    <FormControl
                                        size="small"
                                        sx={{
                                            minWidth: 160,
                                            backgroundColor: '#3e4451',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <InputLabel
                                            id="demo-simple-select-label"
                                            sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '12px',
                                                color: '#fff',
                                                '&.Mui-focused': {
                                                    color: '#fff',
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                },
                                            }}
                                        >
                                            Select Language
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={value}
                                            label="Select Option"
                                            onChange={handleChange}
                                            sx={{
                                                fontSize: '12px',
                                                color: '#fff',
                                                borderRadius: '8px',
                                                '.MuiSvgIcon-root': { color: '#fff' },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'transparent',
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#fff',
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#fff',
                                                },
                                            }}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: '6px',
                                                        backgroundColor: '#3e4451',
                                                        color: '#fff',
                                                        fontSize: '12px',
                                                        fontFamily: '"Segoe UI", sans-serif',
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem value="option1">Option 1</MenuItem>
                                            <MenuItem value="option2">Option 2</MenuItem>
                                            <MenuItem value="option3">Option 3</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid sx={{ borderBottom: '1px solid #585858', width: '100%', marginTop: '10px', marginBottom: '30px' }}></Grid>
                    <Grid container spacing={2} sx={{ gap: '15px', }}>
                        <Grid size={{ md: 3, xs: 12 }} sx={{
                            textAlign: 'center', "@media (max-width:600px)": {
                                textAlign: 'left',
                            },
                        }}>
                            <img src={SaftyIcon} alt="" />
                            <Typography sx={styleCss.SaftyHeadStyle}>
                                Safety + Certified
                            </Typography>
                            <Typography sx={styleCss.VerificationStyle}>
                                GPS tracked buses with verified drivers
                            </Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }} sx={{
                            textAlign: 'center', "@media (max-width:600px)": {
                                textAlign: 'left',
                            },
                        }}>
                            <img src={SaftyIcon1} alt="" />
                            <Typography sx={styleCss.SaftyHeadStyle}>
                                Secure Payments
                            </Typography>
                            <Typography sx={styleCss.VerificationStyle}>
                                SSL encrypted payment gateway
                            </Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }} sx={{ textAlign: 'center', marginTop: '30px' }}>
                            <Typography sx={styleCss.SaftyHeadStyle}>
                                ISO Certified
                            </Typography>
                            <Typography sx={styleCss.VerificationStyle}>
                                Quality management certified
                            </Typography>
                        </Grid>
                        <Grid size={{ md: 3, xs: 12 }} sx={{
                            textAlign: 'center', "@media (max-width:600px)": {
                                textAlign: 'left',
                            },
                        }}>
                            <img src={SaftyIcon2} alt="" />
                            <Typography sx={styleCss.SaftyHeadStyle}>
                                25M+ Customers
                            </Typography>
                            <Typography sx={styleCss.VerificationStyle}>
                                Trusted by millions worldwide
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid sx={styleCss.StayUpdatedbox}>
                        <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Typography sx={styleCss.StayUpdatedStyle}>Stay Updated</Typography>
                                <Typography sx={styleCss.LatestOffers}>Get the latest offers and updates directly in your inbox</Typography>
                            </Grid>
                            <Grid size={{ md: 6, xs: 12 }} sx={{
                                textAlign: 'right', "@media (max-width:600px)": {
                                    textAlign: 'left',
                                },
                            }}>
                                <TextField
                                    variant="outlined"
                                    placeholder="Enter Your email"
                                    sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        fontStretch: 'normal',
                                        color: '#dedede',
                                        textAlign: 'left',
                                        '& .MuiInputBase-input': {
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            color: '#dedede',
                                            padding: '10px 12px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '6px',
                                            '& fieldset': {
                                                borderColor: '#ccc',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#999',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#1976d2',
                                            },
                                        },
                                        "@media (max-width:600px)": {
                                            width: '100%',
                                        },
                                    }}
                                />
                                <Button variant="contained" sx={{
                                    padding: '8px 20px',
                                    borderRadius: '5px',
                                    backgroundColor: '#ff5714',
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    color: '#fff',
                                    textTransform: 'none',
                                    marginLeft: '15px',
                                    '&:hover': {
                                        backgroundColor: '#e04e0f',
                                    },
                                    "@media (max-width:600px)": {
                                        width: '100%',
                                        marginLeft: '0',
                                        marginTop: '10px',
                                    },
                                }}>
                                    Subscribe
                                </Button>

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ marginTop: '20px', alignItems: 'center' }}>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Typography sx={styleCss.FolloesText}>Follow us:</Typography>
                                <List sx={styleCss.ListFooterBottom}>
                                    <ListItem sx={{ paddingLeft: '10px' }}>
                                        <Link to={'/'}>
                                            <img src={SocialIcon1} alt="" />
                                        </Link>
                                    </ListItem>
                                    <ListItem sx={{ paddingLeft: '10px' }}>
                                        <Link to={'/'}>
                                            <img src={SocialIcon2} alt="" />
                                        </Link>
                                    </ListItem>
                                    <ListItem sx={{ paddingLeft: '10px' }}>
                                        <Link to={'/'}>
                                            <img src={SocialIcon3} alt="" />
                                        </Link>
                                    </ListItem>
                                    <ListItem sx={{ paddingLeft: '10px' }}>
                                        <Link to={'/faq'}>
                                            <img src={SocialIcon4} alt="" />
                                        </Link>
                                    </ListItem>
                                </List>
                            </Box>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <Box sx={{
                                display: 'flex', justifyContent: 'flex-end', gap: '20px', flexWrap: 'nowrap', "@media (max-width:600px)": {
                                    gap: '0px',
                                    justifyContent: 'start'
                                },
                            }}>
                                <Link to='/' style={styleCss.ListviewBottom}>Privacy Policy</Link>
                                <Link to='/' style={styleCss.ListviewBottom}>Terms & Conditions</Link>
                                <Link to='/' style={styleCss.ListviewBottom}>FAQ</Link>
                                <Link to='/' style={styleCss.ListviewBottom}>About Us</Link>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>

            </Grid>
            <Grid sx={styleCss.FooterBottomstyle}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Typography sx={styleCss.RightsStyle}>@2025 starBus. All rights reserved.</Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Grid>
        </>
    )
};

export default Footer